import customFieldsMetaReducer from './customFieldsMetaReducer';

export default customFieldsMetaReducer;
